import { Action } from 'modules/store'

// tslint:disable-next-line:no-empty-interface
export interface State {}

const initialState = {}
export const reducer = (state = initialState, action: Action): State => state



// WEBPACK FOOTER //
// ./src/app/core/store/core.reducers.ts